var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("q-form", { ref: "editForm" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-md-12 col-lg-12" },
        [
          _vm.popupParam.opmFolderDetailId
            ? _c(
                "c-card",
                {
                  staticClass: "cardClassDetailForm revisionLayout",
                  attrs: { title: "LBLREV", topClass: "topcolor-orange" },
                },
                [
                  _c("template", { slot: "card-detail" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
                      },
                      [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-1" },
                            [
                              _c("c-text", {
                                attrs: {
                                  required: _vm.editable && _vm.isRevision,
                                  editable: _vm.editable && _vm.isRevision,
                                  label: "LBLREVNO",
                                  name: "revisionNum",
                                },
                                model: {
                                  value: _vm.folderDetail.revisionNum,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.folderDetail,
                                      "revisionNum",
                                      $$v
                                    )
                                  },
                                  expression: "folderDetail.revisionNum",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-2" },
                            [
                              _c("c-text", {
                                attrs: {
                                  editable: false,
                                  label: "LBLREVPERIOD",
                                  name: "regDtStr",
                                },
                                model: {
                                  value: _vm.folderDetail.regDtStr,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.folderDetail, "regDtStr", $$v)
                                  },
                                  expression: "folderDetail.regDtStr",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-1" },
                            [
                              _c("c-text", {
                                attrs: {
                                  editable: false,
                                  label: "LBLREVUSER",
                                  name: "regUserName",
                                },
                                model: {
                                  value: _vm.folderDetail.regUserName,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.folderDetail,
                                      "regUserName",
                                      $$v
                                    )
                                  },
                                  expression: "folderDetail.regUserName",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "col-4" },
                            [
                              _c("c-text", {
                                attrs: {
                                  required: _vm.editable && _vm.isRevision,
                                  editable: _vm.editable && _vm.isRevision,
                                  label: "LBLREVREASON",
                                  name: "revisionContent",
                                },
                                model: {
                                  value: _vm.folderDetail.revisionContent,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.folderDetail,
                                      "revisionContent",
                                      $$v
                                    )
                                  },
                                  expression: "folderDetail.revisionContent",
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ],
                2
              )
            : _vm._e(),
          _c(
            "c-card",
            {
              staticClass: "cardClassDetailForm",
              attrs: { title: "LBL0010605" },
            },
            [
              _c(
                "template",
                { slot: "card-select" },
                [
                  _vm.popupParam.opmFolderDetailId
                    ? _c("c-select", {
                        attrs: {
                          editable: !_vm.isRevision,
                          comboItems: _vm.gridrev.data,
                          type: "custom",
                          typetext: "LBL0010565",
                          itemText: "revisionNum",
                          itemValue: "opmFolderDetailId",
                          name: "selectedOpmFolderDetailId",
                          label: "",
                        },
                        on: { input: _vm.rowClickRev },
                        model: {
                          value: _vm.selectedOpmFolderDetailId,
                          callback: function ($$v) {
                            _vm.selectedOpmFolderDetailId = $$v
                          },
                          expression: "selectedOpmFolderDetailId",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
              _c(
                "template",
                { slot: "card-button" },
                [
                  _c(
                    "q-btn-group",
                    { attrs: { outline: "" } },
                    [
                      _c("c-btn", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.editable &&
                              _vm.popupParam.opmFolderDetailId &&
                              !_vm.isRevision &&
                              _vm.isEnalbed,
                            expression:
                              "(editable && popupParam.opmFolderDetailId && !isRevision) && isEnalbed",
                          },
                        ],
                        attrs: { label: "LBLREV", icon: "restart_alt" },
                        on: { btnClicked: _vm.setRevision },
                      }),
                      _c("c-btn", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value:
                              _vm.editable &&
                              _vm.popupParam.opmFolderDetailId &&
                              _vm.isRevision &&
                              _vm.isEnalbed,
                            expression:
                              "(editable && popupParam.opmFolderDetailId && isRevision) && isEnalbed",
                          },
                        ],
                        attrs: { label: "LBLREVCANCEL", icon: "restart_alt" },
                        on: { btnClicked: _vm.cancelRevision },
                      }),
                      _vm.editable &&
                      _vm.popupParam.opmFolderDetailId &&
                      _vm.isEnalbed
                        ? _c("c-btn", {
                            attrs: { label: "LBLREMOVE", icon: "remove" },
                            on: { btnClicked: _vm.deleteData },
                          })
                        : _vm._e(),
                      _vm.editable
                        ? _c("c-btn", {
                            attrs: {
                              url: _vm.saveUrl,
                              isSubmit: _vm.isSave,
                              param: _vm.folderDetail,
                              mappingType: _vm.saveType,
                              label: "LBLSAVE",
                              icon: "save",
                            },
                            on: {
                              beforeAction: _vm.saveFolderDetail,
                              btnCallback: _vm.saveCallback,
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("template", { slot: "card-detail" }, [
                _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c("c-text", {
                      attrs: {
                        required: "",
                        disabled: _vm.isRevision,
                        editable: _vm.editable,
                        label: "LBL0010596",
                        name: "folderDetailName",
                      },
                      model: {
                        value: _vm.folderDetail.folderDetailName,
                        callback: function ($$v) {
                          _vm.$set(_vm.folderDetail, "folderDetailName", $$v)
                        },
                        expression: "folderDetail.folderDetailName",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-3" },
                  [
                    _c("c-datepicker", {
                      attrs: {
                        label: "LBL0010597",
                        disabled: _vm.isRevision,
                        editable: _vm.editable,
                        name: "standardDate",
                      },
                      model: {
                        value: _vm.folderDetail.standardDate,
                        callback: function ($$v) {
                          _vm.$set(_vm.folderDetail, "standardDate", $$v)
                        },
                        expression: "folderDetail.standardDate",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-3" },
                  [
                    _c("c-plant", {
                      attrs: {
                        required: true,
                        disabled: _vm.isRevision,
                        editable: _vm.editable,
                        type: "edit",
                        name: "plantCd",
                      },
                      model: {
                        value: _vm.folderDetail.plantCd,
                        callback: function ($$v) {
                          _vm.$set(_vm.folderDetail, "plantCd", $$v)
                        },
                        expression: "folderDetail.plantCd",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            2
          ),
          _c(
            "div",
            { staticStyle: { "padding-top": "20px !important" } },
            [
              _c("c-upload", {
                attrs: {
                  attachInfo: _vm.attachInfo,
                  editable: _vm.editable,
                  label: "LBL0010606",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }